module.exports = {"130571100":"东汪镇","130571101":"王快镇","130571103":"沙河城镇","130571104":"留村镇","130571400":"市高新技术开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130571.json
// module id = 236
// module chunks = 0